/**
 * Russian Localization
 */

export default {

  /**
   * Общие тексты отказов — по машиночитаемому признаку причины.
   * Норма: spec/invariants/api-errors.md (R04, R06–R08).
   * Зональные признаки ищутся раньше: `<зона>.errors.<признак>`.
   */
  errors: {
    INTERNAL_ERROR: 'Сбой на стороне продукта. Повторите позже',
    NOTE_FORMAT_NOT_MARKDOWN: 'Заметка сохраняется в формате Markdown. Уберите разметку HTML (тег «{tag}») — чтобы показать её примером, поместите её в код',
    NOT_FOUND: 'Объект не найден',
    // Опечатка в запросе отличима от «объекта нет» (invariants/api-errors).
    INVALID_ID: 'Некорректный идентификатор: «{id}»',
    INVALID_LIMIT: 'Некорректное количество записей: «{limit}»',
    // Запрос не той формы: продукт называет параметр отбора или поле данных,
    // из-за которого действие отклонено (api-errors-R06, R07). Названия может
    // не быть — тогда берётся безымянный вариант текста (`_UNNAMED`).
    QUERY_PARAM_UNKNOWN:
        'Запрос содержит параметр отбора «{param}», который продукт не принимает. Обновите страницу и повторите',
    QUERY_PARAM_UNKNOWN_UNNAMED:
        'Запрос содержит параметр отбора, который продукт не принимает. Обновите страницу и повторите',
    QUERY_PARAM_MISSING:
        'В запросе не хватает обязательного параметра отбора «{param}». Обновите страницу и повторите',
    QUERY_PARAM_MISSING_UNNAMED:
        'В запросе не хватает обязательного параметра отбора. Обновите страницу и повторите',
    QUERY_PARAM_INVALID:
        'Значение параметра отбора «{param}» недопустимо. Измените условия отбора и повторите',
    QUERY_PARAM_INVALID_UNNAMED:
        'Значение одного из параметров отбора недопустимо. Измените условия отбора и повторите',
    BODY_INVALID:
        'Продукт не смог разобрать отправленные данные. Обновите страницу и повторите — если отказ повторяется, сообщите администратору',
    BODY_FIELD_UNKNOWN:
        'В отправленных данных есть поле «{field}», которое продукт не принимает. Обновите страницу и повторите',
    BODY_FIELD_UNKNOWN_UNNAMED:
        'В отправленных данных есть поле, которое продукт не принимает. Обновите страницу и повторите',
    BODY_FIELD_MISSING:
        'В отправленных данных не хватает обязательного поля «{field}». Заполните его и повторите',
    BODY_FIELD_MISSING_UNNAMED:
        'В отправленных данных не хватает обязательного поля. Заполните обязательные поля и повторите',
    BODY_FIELD_INVALID:
        'Значение поля «{field}» недопустимо. Исправьте его и повторите',
    BODY_FIELD_INVALID_UNNAMED:
        'Значение одного из полей недопустимо. Проверьте введённые данные и повторите',
    METHOD_NOT_ALLOWED: 'Действие не поддерживается для этого адреса',
    UNKNOWN_ERROR: 'Не удалось выполнить действие',
    NETWORK_ERROR: 'Нет связи с сервером. Проверьте подключение и повторите',
    LOAD_FAILED: 'Не удалось загрузить данные',
    CREATE_FAILED: 'Не удалось создать',
    UPDATE_FAILED: 'Не удалось обновить',
    DELETE_FAILED: 'Не удалось удалить',
    // Архивный коммит только для чтения
    // (spec/features/business-model/versioning.md, R25).
    FEATURE_IS_ARCHIVED_COMMIT: 'Это архивный коммит — его содержимое доступно только для чтения. Переключитесь на текущую версию фичи',
    // Название проекта: непустота и уникальность
    // (spec/features/administration/projects.md, R04; spec/invariants/naming.md).
    PROJECT_NAME_EMPTY: 'Название проекта не может быть пустым',
    // Удержания фичи при удалении
    // (spec/features/business-model/feature-lifecycle.md, R13).
    FEATURE_HELD_BY_DESCENDANTS:
        'У фичи есть ответвления ({descendants}): удалить её нельзя, пока они существуют',
    FEATURE_HELD_BY_DATAMARTS:
        'В фиче остались витрины ({datamarts}) и папки витрин ({folders}): сначала удалите их',
    PROJECT_NAME_EXISTS: 'Проект с названием «{name}» уже есть',
    // Название фичи: уникальность в проекте и закрытый перечень статусов
    // (spec/features/business-model/features.md, R04, R06).
    FEATURE_NAME_EXISTS: 'Фича с названием «{name}» в проекте уже есть',
    FEATURE_STATUS_INVALID: 'Недопустимый статус фичи: «{status}». Допустимы: {allowed}',
    // Ключ шифрования сменился: сохранённые секреты источников зашифрованы
    // прежним ключом и не читаются. Пользователь обязан понять причину и выход
    // (spec/invariants/encryption.md, R06, R07).
    ENCRYPTION_KEY_MISMATCH:
        'Секрет подключения зашифрован прежним ключом шифрования и больше не читается. Введите секрет заново и сохраните источник',
    // Отказ пути синхронизации/профилирования метаданных: причина и параметры
    // приходят машиночитаемыми (api-errors-R06, R07), а не свободной строкой
    // (spec/bugs/2026-08-10_17-30_sync-history-drops-failure-reason.md).
    SOURCE_ERROR: 'Источник недоступен или отклонил запрос. Проверьте источник и повторите позже',
    SYNC_TIMEOUT: 'Синхронизация не уложилась в отведённое время ({seconds} с)',
    SYNC_FAILED: 'Синхронизация не удалась',
    PROFILING_TIMEOUT: 'Профилирование не уложилось в отведённое время ({seconds} с)',
    PROFILING_FAILED: 'Профилирование не удалось',
    HTTP_400: 'Запрос отклонён: некорректные данные',
    HTTP_401: 'Сессия истекла. Войдите заново',
    HTTP_403: 'Действие недоступно: недостаточно прав',
    HTTP_404: 'Объект не найден',
    HTTP_409: 'Действие противоречит текущему состоянию',
    HTTP_422: 'Запрос отклонён: некорректные данные',
    HTTP_500: 'Сбой на стороне продукта. Повторите позже',
    HTTP_502: 'Сбой на стороне продукта. Повторите позже',
    HTTP_503: 'Продукт временно недоступен. Повторите позже',
  },
  common: {
    cancel: 'Отмена',
    save: 'Сохранить',
    create: 'Создать',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    loading: 'Загрузка...',
    close: 'Закрыть',
    details: 'Детали',
    actions: 'Действия',
    name: 'Название',
    description: 'Описание',
    required: 'Обязательно',
    rename: 'Переименовать',
    admin: 'Админ',
    saveSuccess: 'Успешно сохранено',
    saveError: 'Не удалось сохранить',
    noteNotLoaded: 'Заметка не загружена — редактирование недоступно. Повторите попытку',
  },
  
  app: {
    title: 'MetaBridge',
    menu: 'Меню',
  },
  
  nav: {
    sourceExplorer: 'Обзор источников',
    businessLayer: 'Бизнес-слой',
    mapping: 'Маппинг',
    etl: 'ETL',
    datamarts: 'Витрины',
    changeHistory: 'История изменений',
    admin: {
      users: 'Пользователи',
    },
  },
  
  project: {
    select: 'Выберите проект',
    create: 'Создать новый проект...',
    createTitle: 'Создать новый проект',
    name: 'Название проекта',
    namePlaceholder: 'Мой проект',
    description: 'Описание',
    descriptionPlaceholder: 'Описание проекта (опционально)',
    created: 'Проект "{name}" создан!',
    loadError: 'Не удалось загрузить список проектов',
    createError: 'Не удалось создать проект',
    // Проект из ссылки не существует либо не виден актору — одно и то же
    // (shell-routing-R12, rbac-R23): подмены доступным проектом нет.
    notFoundInLink: 'Проект из ссылки не найден',
  },
  
  source: {
    dataSources: 'Источники данных',
    statisticsRefreshed: 'Статистика таблицы обновлена',
    addSource: 'Добавить источник данных',
    addSourceTitle: 'Добавить новый источник данных',
    editSourceTitle: 'Редактировать источник данных',
    name: 'Название источника',
    namePlaceholder: 'Моя база данных',
    type: 'Тип базы данных',
    host: 'Хост',
    port: 'Порт',
    database: 'Название базы данных',
    username: 'Имя пользователя',
    password: 'Пароль',
    passwordPlaceholder: 'Оставьте пустым, чтобы сохранить текущий пароль',
    testConnection: 'Проверить подключение',
    testConnectionSuccess: 'Подключение успешно!',
    testConnectionFailed: 'Ошибка подключения',
    created: 'Источник "{name}" успешно создан!',
    updated: 'Источник "{name}" успешно обновлён!',
    createError: 'Не удалось создать источник',
    updateError: 'Не удалось обновить источник',
    notSynced: 'Не синхронизирован',
    // Состояния синхронизации источника в подсказке узла дерева. Ключей не
    // было ни в одной локали, и пользователь видел сам ключ (i18n-R02).
    synced: 'Синхронизирован',
    syncing: 'Синхронизация выполняется',
    loadError: 'Не удалось загрузить источники',
    notFound: 'Источник не найден: {name}',
    syncSuccess: 'Метаданные успешно синхронизированы',
    syncQueued: 'Соединение установлено, синхронизация поставлена в очередь',
    syncError: 'Не удалось синхронизировать метаданные',
    refresh: 'Обновить метаданные',
    settings: 'Настройки источника',
    selectSourceFirst: 'Пожалуйста, выберите источник',
    schema: 'Схема',
    table: 'Таблица',
    selectTable: 'Выберите таблицу для просмотра колонок',
    neverSynced: 'Ещё не синхронизирован. Нажмите Обновить для загрузки метаданных.',
    lastSyncFailed: 'Ошибка синхронизации {timeAgo}',
    lastSynced: 'Синхронизировано {timeAgo}',
    justNow: 'только что',
    minutesAgo: '{count} мин назад',
    hoursAgo: '{count} ч назад',
    daysAgo: '{count} дн назад',
    description: 'Описание источника',
    descriptionPlaceholder: 'Опишите этот источник данных...',
    descriptionEditHint: 'Нажмите Esc для отмены',
    clickToAddDescription: 'Нажмите, чтобы добавить описание',
    copyLink: 'Копировать ссылку на источник',
    linkCopied: 'Ссылка на источник скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку на источник',
    deleteTitle: 'Удаление источника',
    deleteConfirm: 'Удалить источник «{name}»? Все метаданные, заметки и теги будут скрыты.',
    deleteSuccess: 'Источник «{name}» удалён',
    deleteError: 'Не удалось удалить источник',
    noDeletePermission: 'Нет прав на удаление источника',
    moreActions: 'Ещё',
    schemasTitle: 'Схемы',
    schemasEmpty: 'В этом источнике нет схем',
    schemasHidden: 'Скрыта',
    schemasHiddenCount: 'Скрыто: {count}',
    schemasNoDescription: 'Нет описания',
    schemasNoTags: 'Без тегов',
    schemasSearchPlaceholder: 'Поиск по схемам...',
    schemasVisibilityPlaceholder: 'Видимость',
    schemasFilterAll: 'Показать все',
    schemasFilterHidden: 'Только скрытые',
    schemasFilterVisible: 'Без скрытых',
    schemasTagsPlaceholder: 'Фильтр по тегам',
    schemaName: 'Схема',
    schemaTables: 'Таблицы',
    schemaDescription: 'Описание',
    schemaTags: 'Теги',
    schemasHide: 'Скрывать',
    schemasLoadFailed: 'Не удалось загрузить схемы источника',
    hiddenSchemasLoadFailed: 'Не удалось загрузить скрытые схемы',
    hiddenSchemasSaveFailed: 'Не удалось сохранить скрытые схемы',
    schemaNotesLoadFailed: 'Не удалось загрузить описания схем',
    moveToGroup: {
      action: 'Перенести в другую группу',
      title: 'Перенос источника',
      message: 'Выберите группу для источника «{name}»:',
      selectGroup: 'Выберите группу',
      confirm: 'Перенести',
      success: 'Источник «{name}» перенесён в группу «{group}»',
      noOtherGroups: 'Нет других групп для переноса',
      error: 'Не удалось перенести источник',
    },
    ssh: {
      tab: 'SSH-туннель',
      enable: 'Использовать SSH-туннель',
      host: 'SSH-хост',
      port: 'SSH-порт',
      username: 'SSH-пользователь',
      authMethod: 'Аутентификация',
      authPassword: 'Пароль',
      authPrivateKey: 'Приватный ключ',
      password: 'SSH-пароль',
      privateKeyPath: 'Путь к приватному ключу',
      privateKeyPathPlaceholder: '/home/user/.ssh/id_rsa',
      passphrase: 'Пароль ключа',
      timeout: 'Таймаут подключения (с)',
      keepalive: 'Поддерживать соединение',
      keepaliveInterval: 'Интервал (с)',
      testConnection: 'Тест SSH',
      testSuccess: 'SSH-подключение успешно!',
      testFailed: 'SSH-подключение не удалось',
      passwordPlaceholder: 'Оставьте пустым для сохранения текущего',
      advanced: 'Дополнительно',
    },
    andMoreTables: '...и ещё {count}',
    tableType: {
      table: 'Таблица',
      view: 'Представление',
      materializedView: 'Материализованное представление',
    },
    odbc: {
      driver: 'ODBC-драйвер',
      driverPlaceholder: 'Выберите ODBC-драйвер',
      driverLoading: 'Загрузка драйверов...',
      noDrivers: 'На сервере не найдены ODBC-драйверы',
      template: 'Шаблон подключения',
      templatePlaceholder: 'Выберите тип БД',
      templateLoading: 'Загрузка шаблонов...',
      unavailable: 'ODBC не доступен на сервере',
    },
    errors: {
      TAG_CODE_EMPTY: 'Код тега не может быть пустым',
      TAG_NAME_EMPTY: 'Название тега не может быть пустым',
      TAG_COLOR_INVALID: 'Некорректный код цвета: {color}',
      TAG_CODE_EXISTS: 'Тег с кодом "{code}" в проекте уже есть',
      ODBC_DRIVER_LIST_FAILED: 'Не удалось получить список ODBC-драйверов',
      ODBC_NO_DRIVERS: 'На сервере не установлены ODBC-драйверы',
      ODBC_TEMPLATE_NOT_FOUND: 'Шаблон подключения "{templateId}" не найден',
      ODBC_FIELD_MISSING: 'Обязательное поле "{field}" не заполнено',
      ODBC_FIELD_INVALID: 'Некорректное значение поля "{field}": {reason}',
      ODBC_BUILD_CONN_STR_FAILED: 'Не удалось собрать строку подключения',
      ODBC_CONNECT_FAILED: 'Ошибка подключения через ODBC',
      ODBC_METADATA_FAILED: 'Ошибка извлечения метаданных через ODBC',
      ODBC_ENV_INIT_FAILED: 'ODBC не доступен на сервере',
      SOURCE_NAME_EXISTS: 'Источник с таким именем уже существует',
      SOURCE_NAME_EMPTY: 'Название источника не может быть пустым',
      SOURCE_HOST_EMPTY: 'Укажите адрес источника',
      SOURCE_PORT_OUT_OF_RANGE: 'Порт должен быть от {min} до {max}',
      SOURCE_DATABASE_EMPTY: 'Укажите имя базы данных',
      SOURCE_USERNAME_EMPTY: 'Укажите имя пользователя',
      ODBC_DRIVER_NOT_SELECTED: 'Не выбран ODBC-драйвер',
      ODBC_TEMPLATE_NOT_SELECTED: 'Не выбран шаблон подключения',
      // Переход вверх по дереву каталогов запрещён во всех путевых значениях
      // дочернего объекта (spec/features/data-sources/source-children.md, R14).
      PATH_TRAVERSAL_NOT_ALLOWED:
        'Значение не может содержать «..»: переход вверх по дереву каталогов запрещён (поле: {field})',
      NAME_EXISTS: 'Объект с названием "{name}" у этого источника уже есть',
      PROVIDER_CONFIG_KEY_UNKNOWN:
        'Неизвестная настройка разбора "{key}". Допустимые: {allowed}',
      SOURCE_DB_TYPE_UNSUPPORTED:
        'Способ подключения "{dbType}" не поддерживается. Допустимые: {allowed}. Остальные СУБД подключаются через ODBC',
      SOURCE_SECRET_UNKNOWN:
        'Секрет подключения "{code}" продукту неизвестен. Допустимые: {allowed}',
      ODBC_BUILD_FAILED: 'Не удалось собрать строку подключения ODBC',
      GROUP_NAME_EXISTS: 'Группа с таким названием уже существует',
      GROUP_HAS_SOURCES: 'Невозможно удалить группу: она содержит {count} источник(ов)',
      GROUP_PROJECT_MISMATCH: 'Выбранная группа принадлежит другому проекту',
      // Тип подключения и проект источника задаются при создании и изменению не
      // подлежат: тип определяет, что вообще может быть под источником
      // (spec/features/data-sources/connection.md, R24; sources.md, R12).
      SOURCE_CONNECTION_TYPE_IMMUTABLE:
        'Тип подключения изменить нельзя: источник заведён как «{currentConnectionType}». Заведите новый источник типа «{connectionType}»',
      SOURCE_PROJECT_IMMUTABLE: 'Проект источника изменить нельзя',
      // Вид родителя в дереве источников: подключение — только под группой,
      // дочерний объект — только под подключением или другим дочерним объектом
      // того же источника (spec/schema/entities.md, «Иерархия»).
      PARENT_MUST_BE_GROUP: 'Подключение размещается только в группе',
      PARENT_FROM_ANOTHER_SOURCE: 'Выбранный родитель принадлежит другому источнику',
      NOT_FOUND: 'Объект не найден',
      SSH_AUTH_METHOD_INVALID:
        'Недопустимый способ SSH-аутентификации "{sshAuthMethod}". Допустимые: {allowed}',
      SSH_AUTH_METHOD_REQUIRED:
        'При включённом SSH-туннеле нужно указать способ аутентификации',
      SSH_TIMEOUT_OUT_OF_RANGE:
        'Таймаут SSH должен быть от {min} до {max} секунд',
      SSH_KEEPALIVE_INTERVAL_INVALID:
        'Интервал проверки SSH-соединения должен быть не меньше {min} секунд',
    },
    tab: {
      general: 'Основные',
      ssh: 'SSH-туннель',
    },
  },

  group: {
    groups: 'Группы',
    addGroup: 'Добавить группу',
    addGroupTitle: 'Добавить новую группу',
    editGroupTitle: 'Редактировать группу',
    name: 'Название группы',
    namePlaceholder: 'Введите название группы',
    description: 'Описание',
    descriptionPlaceholder: 'Описание группы (необязательно)',
    sourceCount: '{count} источников',
    deleteConfirm: 'Вы уверены, что хотите удалить группу «{name}»?',
    created: 'Группа «{name}» создана',
    updated: 'Группа «{name}» обновлена',
    deleted: 'Группа удалена',
    loadError: 'Не удалось загрузить группы',
    workspace: {
      sourcesTitle: 'Источники',
      sourcesSearchPlaceholder: 'Поиск по источникам...',
      sourcesEmpty: 'В группе нет источников',
      sourceName: 'Источник',
      sourceSyncStatus: 'Статус синхронизации',
      sourceLastSynced: 'Последняя синхронизация',
      sourceSchemaCount: 'Схемы',
      settings: 'Настройки группы',
      copyLink: 'Копировать ссылку на группу',
      linkCopied: 'Ссылка на группу скопирована',
      linkCopyFailed: 'Не удалось скопировать ссылку на группу',
      deleteTitle: 'Удаление группы',
      deleteDisabledHasSources: 'Удалите все источники перед удалением группы',
      descriptionPlaceholder: 'Описание группы...',
      clickToAddDescription: 'Нажмите, чтобы добавить описание',
    },
  },

  schema: {
    notFound: 'Схема не найдена',
    description: 'Описание схемы',
    descriptionPlaceholder: 'Опишите эту схему...',
    descriptionEditHint: 'Нажмите Esc для отмены',
    clickToAddDescription: 'Нажмите, чтобы добавить описание',
    copyLink: 'Копировать ссылку на схему',
    linkCopied: 'Ссылка на схему скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку на схему',
    tablesTitle: 'Таблицы',
    tablesEmpty: 'В этой схеме нет таблиц',
    tablesShowHidden: 'Показать скрытые',
    tablesHide: 'Скрывать',
    tablesHidden: 'Скрыта',
    tablesHiddenCount: 'Скрыто: {count}',
    tablesNoDescription: 'Нет описания',
    tablesNoTags: 'Без тегов',
    tablesSearchPlaceholder: 'Поиск по таблицам...',
    tablesVisibilityPlaceholder: 'Видимость',
    tablesFilterAll: 'Показать все',
    tablesFilterHidden: 'Только скрытые',
    tablesFilterVisible: 'Без скрытых',
    tablesTagsPlaceholder: 'Фильтр по тегам',
    tableName: 'Таблица',
    tableColumns: 'Колонки',
    tableDescription: 'Описание',
    tableTags: 'Теги',
    tablesLoadFailed: 'Не удалось загрузить таблицы схемы',
    hiddenTablesLoadFailed: 'Не удалось загрузить скрытые таблицы',
    hiddenTablesSaveFailed: 'Не удалось сохранить скрытые таблицы',
    tableNotesLoadFailed: 'Не удалось загрузить описания таблиц',
    batchSelected: 'Выбрано: {count}',
    batchSelectPage: 'Выбрать страницу',
    batchSelectAll: 'Выбрать все ({count})',
    batchClear: 'Очистить',
    batchHide: 'Скрыть',
    batchUnhide: 'Показать',
    batchAddTag: 'Добавить тег',
    batchRemoveTag: 'Убрать тег',
    batchTagsUpdateFailed: 'Не удалось обновить теги таблиц',
  },
  
  table: {
    schemaUnknown: 'Схема таблицы неизвестна — данные не загружены',
    hasPk: 'Есть PK',
    pk: 'PK',
    fk: 'FK',
    columns: 'Колонки',
    rowsEst: 'Строк (прибл.)',
    columnName: 'Название колонки',
    dataType: 'Тип данных',
    nullable: 'Nullable',
    dbComment: 'Комментарий БД',
    noComment: 'Нет комментария',
    analystNote: 'Заметка аналитика',
    addNote: 'Добавить заметку',
    clickToAddNote: 'Кликните для добавления заметки...',
    noteEditPlaceholder: 'Введите заметку... (поддерживается форматирование)',
    noteEditHint: 'Используйте панель инструментов для форматирования. Кликните вне редактора чтобы сохранить.',
    noteSaved: 'Заметка сохранена',
    columnsSelected: 'колонок выбрано',
    selectAll: 'Выбрать все',
    clearSelection: 'Снять выделение',
    appendNote: 'Добавить заметку',
    batchAppendNoteTitle: 'Добавить заметку к выбранным колонкам',
    batchNotePlaceholder: 'Введите текст для добавления ко всем выбранным колонкам...',
    appendToSelected: 'Добавить к {count} колонкам',
    batchNotesSaved: 'Заметки добавлены к {count} колонкам',
    batchNotesSaveFailed: 'Не удалось добавить заметки',
    allColumnsReviewed: 'Все колонки проверены!',
    allColumnsReviewedDesc: 'У каждой колонки в этой таблице есть заметка аналитика. Отличная работа!',
    tableDescriptionPlaceholder: 'Опишите назначение и бизнес-контекст этой таблицы...',
    addTableDescription: 'Нажмите, чтобы добавить описание таблицы',
    editTableNoteHint: 'Нажмите Esc для отмены',
    tableNoteSaved: 'Описание таблицы сохранено',
    notNull: 'NOT NULL',
    yes: 'ДА',
    notFoundInCache: 'Метаданные таблицы не найдены в кэше',
    loadFailed: 'Не удалось загрузить таблицу',
    copyLink: 'Копировать ссылку',
    linkCopied: 'Ссылка скопирована в буфер обмена',
    linkCopyFailed: 'Не удалось скопировать ссылку',
    tabs: {
      columns: 'Колонки',
      schema: 'Схема',
      indexes: 'Индексы',
      constraints: 'Ограничения',
      data: 'Данные',
    },
    schemaEmpty: 'Связей не найдено',
    schemaLoadFailed: 'Не удалось загрузить схему таблицы',
    schemaPartialLoadFailed: 'Часть связанных таблиц не загрузилась',
    schemaRenderFailed: 'Не удалось отрисовать диаграмму',
    schemaRelationsTitle: 'Исходящие связи',
    schemaIncomingRelationsTitle: 'Входящие связи',
    schemaDiagramTitle: 'Диаграмма связей',
    schemaRelations: {
      constraintName: 'Имя связи',
      sourceColumn: 'Поле источника',
      targetTable: 'Целевая таблица',
      targetColumn: 'Поле назначения',
    },
    schemaIncomingRelations: {
      constraintName: 'Имя связи',
      sourceTable: 'Таблица-источник',
      sourceColumn: 'Поле источника',
      targetColumn: 'Поле назначения',
    },
    indexes: {
      name: 'Имя индекса',
      type: 'Тип',
      columns: 'Колонки',
      isUnique: 'Уникальный',
      isPrimary: 'Первичный',
      predicate: 'Условие (WHERE)',
      unique: 'UNIQUE',
      primary: 'PRIMARY',
      empty: 'Индексы не найдены',
      loadFailed: 'Не удалось загрузить индексы',
    },
    constraints: {
      name: 'Имя ограничения',
      type: 'Тип',
      columns: 'Колонки',
      referencedTable: 'Целевая таблица',
      referencedColumns: 'Целевые колонки',
      definition: 'Определение',
      empty: 'Ограничения не найдены',
      loadFailed: 'Не удалось загрузить ограничения',
    },
    dataTab: {
      whereLabel: 'WHERE',
      orderByLabel: 'ORDER BY',
      apply: 'Загрузить данные',
      clear: 'Очистить',
      errorTitle: 'Ошибка выполнения запроса',
    },
  },
  
  coverage: {
    reviewProgress: 'Прогресс проверки',
    total: 'Всего',
    withNotes: 'С заметками',
    needsReview: 'Требует проверки',
    pii: 'PII',
    noDbComment: 'Без комментария БД',
    changed: 'Изменено',
  },
  
  filter: {
    title: 'Фильтры',
    withNotes: 'С заметками',
    withoutNotes: 'Без заметок',
    withDbComment: 'С комментарием БД',
    noDbComment: 'Без комментария БД',
    keys: 'Ключи (PK/FK)',
    primaryKey: 'Первичный ключ',
    foreignKey: 'Внешний ключ',
    reviewMode: 'Режим проверки',
    clearAll: 'Очистить всё',
  },

  comments: {
    title: 'Комментарии',
    empty: 'Комментариев пока нет',
    placeholder: 'Напишите комментарий...',
    add: 'Добавить комментарий',
    retry: 'Повторить',
    loadFailed: 'Не удалось загрузить комментарии',
    createFailed: 'Не удалось добавить комментарий',
    /**
     * Тексты отказов ленты по признаку причины (comments-R11, i18n-R06):
     * ищутся как `comments.errors.<признак>` раньше общих.
     */
    errors: {
      COMMENT_BODY_EMPTY: 'Комментарий не может быть пустым',
      COMMENT_AUTHOR_NOT_ACCEPTED: 'Автор комментария задаётся продуктом и в запросе не принимается',
      AUTHENTICATION_REQUIRED: 'Комментарий можно оставить только после входа в продукт',
      NOT_FOUND: 'Объект обсуждения не найден',
      NETWORK_ERROR: 'Не удалось загрузить комментарии: нет связи с сервером',
    },
  },

  tags: {
    title: 'Теги',
    placeholder: 'Теги',
    loadFailed: 'Не удалось загрузить теги',
    saveFailed: 'Не удалось сохранить теги',
  },
  
  auth: {
    /**
     * Тексты отказов смены пароля по признаку причины
     * (password-change-R07, R08; основание: вердикт 250). Ищутся раньше общих:
     * `auth.errors.<признак>`.
     */
    errors: {
      INVALID_CREDENTIALS: 'Неверный текущий пароль',
      PASSWORD_TOO_WEAK: 'Пароль слишком слабый: минимум 8 символов',
      NEW_PASSWORD_SAME_AS_OLD: 'Новый пароль совпадает со старым',
    },
    profileLoadFailed: 'Не удалось обновить профиль. Повторите позже',
    sectionForbidden: 'Раздел доступен только администратору продукта',
    loginTitle: 'Вход в систему',
    login: 'Войти',
    loginOrEmail: 'Login или Email',
    logout: 'Выйти',
    logoutAll: 'Выйти везде',
    profile: 'Профиль',
    password: 'Пароль',
    changePassword: 'Сменить пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтверждение пароля',
    mustChangePasswordWarning: 'Вы используете временный пароль. Пожалуйста, смените его.',
    passwordChanged: 'Пароль успешно изменен',
    invalidCredentials: 'Неверный login/email или пароль',
    sessionExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
    loginSuccess: 'Вход выполнен успешно',
    loginError: 'Ошибка входа',
    identifierRequired: 'Введите login или email',
    passwordRequired: 'Введите пароль',
    oldPasswordRequired: 'Введите старый пароль',
    newPasswordRequired: 'Введите новый пароль',
    confirmPasswordRequired: 'Подтвердите новый пароль',
    passwordTooShort: 'Пароль должен содержать минимум {min} символов',
    passwordMustBeDifferent: 'Новый пароль должен отличаться от старого',
    passwordsDoNotMatch: 'Пароли не совпадают',
    invalidOldPassword: 'Неверный старый пароль',
    changePasswordError: 'Ошибка смены пароля',
  },
  
  sampleData: {
    title: 'Примеры данных',
    rows: 'строк',
    cached: 'Закэшировано',
    refresh: 'Обновить данные',
    export: 'Экспорт в CSV',
    loading: 'Загрузка данных...',
    noData: 'Нет данных для отображения',
    loadData: 'Загрузить данные',
    justNow: 'только что',
    minutesAgo: '{n} мин назад',
    hoursAgo: '{n} ч назад',
    daysAgo: '{n} дн назад',
    errorTitle: 'Ошибка загрузки данных',
    retry: 'Повторить',
  },
  
  sourceExplorer: {
    // Пометка исчерпанных попыток — НЕ признак причины отказа, а дополнение
    // к тексту причины (data-processing-metadata-sync-R08,
    // source-explorer-profiling-R07; api-errors-R07).
    errorAttemptsExhausted: 'Попытки исчерпаны',
    columnProfile: {
      title: 'Профиль колонки',
      loading: 'Профилирование в процессе...',
      loadingHint: 'Для больших таблиц это может занять несколько минут',
      error: 'Не удалось загрузить профиль',
      timeout: 'Превышено время ожидания. Попробуйте снова или проверьте размер таблицы.',
      refresh: 'Обновить',
      retry: 'Повторить попытку',
      notProfiled: 'Профиль ещё не рассчитан',
      startProfiling: 'Профилировать',
      enqueued: 'Профилирование запущено. Подождите...',
      totalRows: 'Всего строк',
      nonNull: 'Не NULL',
      nullPercent: '% NULL',
      distinctCount: 'Уникальных значений',
      numericStats: 'Числовая статистика',
      min: 'Мин',
      max: 'Макс',
      avg: 'Среднее',
      median: 'Медиана',
      stddev: 'Станд. отклонение',
      textStats: 'Текстовая статистика',
      minLength: 'Мин длина',
      maxLength: 'Макс длина',
      avgLength: 'Сред. длина',
      profiledAt: 'Профилировано',
      topValues: 'Топ-10 значений',
      value: 'Значение',
      count: 'Количество',
      percentage: 'Процент',
    },
    profiling: {
      title: 'Профилирование',
      refresh: 'Обновить',
      settingsTitle: 'Настройки профилирования',
      maxConcurrent: 'Параллельных задач',
      windowStart: 'Окно с',
      windowEnd: 'по',
      saveSettings: 'Сохранить',
      timeHint: 'Время указано по локальному времени',
      queueTitle: 'Очередь профилирования',
      historyTitle: 'История профилирования',
      queueEmpty: 'Очередь пуста',
      historyEmpty: 'История пока пуста',
      schema: 'Схема',
      table: 'Таблица',
      column: 'Поле',
      status: 'Статус',
      createdAt: 'Создано',
      startedAt: 'Запущено',
      completedAt: 'Завершено',
      duration: 'Длительность',
      error: 'Ошибка',
      statusPending: 'В очереди',
      statusProcessing: 'В работе',
      statusCompleted: 'Успешно',
      statusFailed: 'Ошибка',
      queueLoadFailed: 'Не удалось загрузить очередь профилирования',
      historyLoadFailed: 'Не удалось загрузить историю профилирования',
      settingsLoadFailed: 'Не удалось загрузить настройки профилирования',
      settingsSaveFailed: 'Не удалось сохранить настройки профилирования',
      settingsSaved: 'Настройки профилирования сохранены',
    },
    metadataSync: {
      title: 'Синхронизация метаданных',
      refresh: 'Обновить данные',
      currentTask: 'Текущая задача',
      // Состояние задачи, а НЕ признак причины отказа: возврат в ожидание
      // перезапуском отказом не является — попытка не потрачена, задача
      // выполнится сама (api-errors-R12, data-processing-metadata-sync-R10).
      // Потому текст живёт здесь, а не в пространстве `errors.`.
      returnedAfterRestart: 'Задача возвращена в очередь после перезапуска сервиса и будет выполнена заново',
      historyTitle: 'История синхронизаций',
      empty: 'Задач синхронизации нет',
      historyEmpty: 'История синхронизаций пока пуста',
      status: 'Статус',
      startedAt: 'Запущено',
      completedAt: 'Завершено',
      duration: 'Длительность',
      schemas: 'Схемы',
      tables: 'Таблицы',
      columns: 'Поля',
      error: 'Ошибка',
      statusPending: 'В очереди',
      statusProcessing: 'В работе',
      statusCompleted: 'Успешно',
      statusFailed: 'Ошибка',
      queueLoadFailed: 'Не удалось загрузить очередь синхронизации',
      historyLoadFailed: 'Не удалось загрузить историю синхронизаций',
      queued: 'Синхронизация метаданных поставлена в очередь',
    },
  },

  versioning: {
    commit: 'Commit',
    history: 'История',
    loadHistoryError: 'Не удалось загрузить историю',
    commitTitle: 'Создать коммит',
    commitMessage: 'Сообщение коммита',
    commitMessagePlaceholder: 'Опишите изменения (опционально)',
    commitSuccess: 'Коммит успешно создан',
    commitError: 'Не удалось создать коммит',
    historyTitle: 'История коммитов',
    noHistory: 'История пуста',
    noMessage: 'Без описания',
    checkout: 'Checkout',
    checkoutTitle: 'Создать ветку',
    branchName: 'Имя ветки',
    branchNamePlaceholder: 'Введите имя новой ветки',
    branchNameHint: 'Оставьте пустым для автоматического имени',
    checkoutSuccess: 'Ветка успешно создана',
    checkoutError: 'Не удалось создать ветку',
    by: 'от',
  },

  /**
   * Фича как объект: перечень, заведение, свойства, статусы, удаление.
   * Норма: spec/features/business-model/features.md,
   * spec/features/business-model/feature-lifecycle.md.
   */
  feature: {
    select: 'Выберите фичу',
    create: 'Создать фичу...',
    createTitle: 'Создать фичу',
    name: 'Название фичи',
    namePlaceholder: 'Введите название фичи',
    description: 'Описание',
    descriptionPlaceholder: 'Введите описание фичи',
    created: 'Фича «{name}» создана',
    loadError: 'Не удалось загрузить перечень фич',
    createError: 'Не удалось создать фичу',
    selectProjectFirst: 'Сначала выберите проект',
    // Фича из ссылки не принадлежит проекту адреса: открыта другая, и об этом
    // сообщается — молчаливого переноса выбора между проектами нет
    // (shell-routing-R12, features-R10).
    notInLinkProject: 'Фича из ссылки в этом проекте недоступна — открыта другая',
    // Перечень фич проекта (feature-lifecycle-R11)
    manageTitle: 'Фичи проекта',
    listEmpty: 'В проекте нет фич',
    selected: 'выбрана',
    // Архивные фичи на поверхности (feature-lifecycle-R28)
    showArchived: 'Показывать архивные',
    restore: 'Вернуть из архива',
    restoreTitle: 'Вернуть фичу из архива',
    restored: 'Фича «{name}» возвращена из архива',
    // Диалог свойств (feature-lifecycle-R04, R08)
    properties: 'Свойства',
    propertiesTitle: 'Свойства фичи',
    status: 'Статус',
    statuses: {
      draft: 'Черновик',
      in_progress: 'В работе',
      review: 'На проверке',
      merged: 'Влита',
      archived: 'Архивная',
    },
    saved: 'Изменения сохранены',
    // Подтверждение удаления (feature-lifecycle-R14, R18)
    deleteTitle: 'Удалить фичу «{name}»?',
    deleteCascade: 'Вместе с фичей будут удалены её бизнес-модель и маппинги.',
    deleteIrreversible: 'Действие необратимо: восстановить фичу будет нельзя, и отменой удаление не откатывается.',
    deleteArchiveHint: 'Чтобы скрыть фичу, сохранив её содержимое, переведите её в статус «Архивная» вместо удаления.',
    deleted: 'Фича «{name}» удалена',
  },

  markdownEditor: {
    preview: 'Просмотр',
    previewTooltip: 'Показать заметку так, как её увидят другие',
    previewEmpty: 'Заметка пуста',
    formatHint: 'Формат заметки — Markdown. Разметка HTML не принимается; чтобы показать её примером, поместите её в код.',
    boldTooltip: 'Жирный',
    boldPlaceholder: 'жирный текст',
    italicTooltip: 'Курсив',
    italicPlaceholder: 'курсив',
    strikeTooltip: 'Зачёркнутый',
    strikePlaceholder: 'зачёркнутый текст',
    codeTooltip: 'Код',
    codePlaceholder: 'код',
    headingTooltip: 'Заголовок',
    bulletListTooltip: 'Маркированный список',
    orderedListTooltip: 'Нумерованный список',
    quoteTooltip: 'Цитата',
    linkTooltip: 'Вставить ссылку',
    linkLabel: 'ссылка',
    promptEnterLinkUrl: 'Введите адрес ссылки:',
    imageLabel: 'изображение',
    imageSizeExceeded: 'Размер изображения не должен превышать 5 МБ',
    invalidImageFile: 'Загрузите файл изображения',
    imageReadFailed: 'Не удалось прочитать изображение',
    uploadImageTooltip: 'Загрузить изображение',
    insertImageUrlTooltip: 'Вставить изображение по адресу',
    promptEnterImageUrl: 'Введите адрес изображения:',
  },

  richTextEditor: {
    imageSizeExceeded: 'Размер изображения не должен превышать 5 МБ',
    invalidImageFile: 'Загрузите файл изображения',
    imageReadFailed: 'Не удалось прочитать изображение',
    uploadImageTooltip: 'Загрузить изображение',
    insertImageUrlTooltip: 'Вставить изображение по URL',
    promptEnterImageUrl: 'Введите URL изображения:',
  },

  bm: {
    packages: {
      confirmDeletePackage: 'Удалить пакет "{name}" и всё его содержимое?',
      confirmDeleteDiagram: 'Удалить диаграмму "{name}"?',
      deletePackageTitle: 'Удалить пакет',
      deleteDiagramTitle: 'Удалить диаграмму',
    },
    tree: {
      title: 'Пакеты и диаграммы',
      // Отказ группового перемещения называет узел, на котором он произошёл
      // (business-model-packages-R21, R22).
      moveNodeFailed: 'Не удалось переместить «{name}»',
      contextMenu: {
        createPackage: 'Создать пакет',
        createDiagram: 'Создать диаграмму',
        createClass: 'Создать класс',
        rename: 'Переименовать',
        delete: 'Удалить',
        editClass: 'Редактировать',
        renameClass: 'Переименовать',
        deleteClass: 'Удалить класс',
        confirmDeleteClass: 'Удалить класс "{name}"? Это действие нельзя отменить.',
        deleteClassTitle: 'Удалить класс',
      },
    },
    toolbar: {
      createClass: 'Создать класс',
      className: 'Класс',
      undo: 'Отменить (Ctrl+Z)',
      redo: 'Повторить (Ctrl+Shift+Z)',
      save: 'Сохранить (Ctrl+S)',
      saveName: 'Сохранить',
      zoomIn: 'Увеличить',
      zoomOut: 'Уменьшить',
      fitView: 'По размеру экрана',
      unlock: 'Разблокировать',
      lock: 'Заблокировать',
      hideMinimap: 'Скрыть миникарту',
      showMinimap: 'Показать миникарту',
      disableSnapToGrid: 'Выключить привязку к сетке',
      enableSnapToGrid: 'Включить привязку к сетке',
      exportPng: 'Экспорт в PNG',
      exportSuccess: 'Диаграмма экспортирована',
      exportError: 'Не удалось экспортировать диаграмму',
    },
    hiddenEdges: 'Есть скрытые связи',
    noFields: 'Нет полей',
    noValues: 'Нет значений',
    canvas: {
      loadingGraph: 'Загрузка графа...',
      openDiagramHint: 'Откройте диаграмму из списка слева',
    },
    contextMenu: {
      createClass: 'Создать класс',
      showAllEdges: 'Показать все связи',
      removeFromDiagram: 'Убрать с диаграммы',
      deleteClass: 'Удалить класс',
      hideEdge: 'Скрыть связь',
    },
    diagram: {
      defaultName: 'диаграмму',
      saveError: 'Ошибка сохранения диаграммы',
      changesSaved: 'Изменения сохранены',
      noDiagramSelected: 'Диаграмма не выбрана',
      classAlreadyOnDiagram: 'Класс уже на диаграмме',
      unsavedChangesConfirm: 'Диаграмма "{name}" содержит несохранённые изменения.\n\nСохранить изменения перед закрытием?',
      classCreatedLocally: 'Класс создан локально. Сохраните изменения.',
      changesLocalSave: 'Изменения сохранены локально. Сохраните диаграмму.',
      classCreated: 'Класс создан',
      createClassError: 'Не удалось создать класс',
    },
    errors: {
      MISSING_SOURCE_ID: 'Источник не выбран. Выберите источник и повторите',
      // Поле без выбранного типа и цикл наследования (fields-R29, classes-R12)
      FIELD_TYPE_NOT_SELECTED: 'У поля «{field}» не выбран тип: класс не сохранён',
      // Отказы составного действия «класс вместе с полями» (classes-R25, R26):
      // при сбое любой части действие отклоняется целиком, и пользователь
      // видит именно его причину, а не обобщённый текст (api-errors-R05, R08).
      CLASS_NAME_EXISTS: 'Класс с названием «{name}» в этой фиче уже есть',
      CLASS_NAME_EMPTY: 'Название класса не может быть пустым',
      FIELD_NAME_EXISTS: 'Поле с названием «{name}» в этом классе уже есть: класс не сохранён',
      FIELD_NAME_EMPTY: 'Название поля не может быть пустым: класс не сохранён',
      ENUM_VALUE_EXISTS: 'Значение «{value}» в этом перечислении уже есть: класс не сохранён',
      ENUM_VALUE_EMPTY: 'Значение перечисления не может быть пустым: класс не сохранён',
      CLASS_TYPE_CANNOT_HAVE_FIELDS: 'Класс этого типа полей не имеет',
      CLASS_IS_NOT_ENUM: 'Значения перечисления есть только у перечисления',
      DIAGRAM_FROM_ANOTHER_FEATURE: 'Диаграмма «{name}» принадлежит другой фиче — разместить на ней класс нельзя',
      MIN_CARDINALITY_NEGATIVE: 'Нижняя граница количества не может быть отрицательной',
      MAX_CARDINALITY_LESS_THAN_MIN: 'Верхняя граница количества не может быть меньше нижней',
      CLASS_INHERITANCE_CYCLE: 'Класс не может стать своим предком: это замкнуло бы наследование в кольцо',
      CLASS_HAS_CHILDREN: 'Невозможно удалить класс: есть {count} дочерних классов',
      CLASS_HAS_REFERENCES: 'Невозможно удалить класс: на него ссылаются {count} полей',
      CANNOT_DELETE_PRIMITIVE: 'Невозможно удалить примитивный тип',
      CANNOT_CREATE_PRIMITIVE: 'Создание примитивных типов запрещено',
      CANNOT_MODIFY_PRIMITIVE: 'Примитивный тип — константа платформы: изменить его нельзя',
      ENUM_CANNOT_CHANGE_TYPE: 'Тип перечисления не может быть изменён',
      PRIMITIVE_CANNOT_CHANGE_TYPE: 'Тип примитива не может быть изменён',
      INVALID_TYPE_CHANGE: 'Недопустимая смена типа класса',
      EXTENSION_CANNOT_BE_ABSTRACT: 'Расширение не может быть абстрактным',
      ENUM_CANNOT_BE_ABSTRACT: 'Перечисление не может быть абстрактным',
      ONLY_CONCRETE_CAN_HAVE_PARENT: 'Только классы могут иметь родителя',
      PARENT_MUST_BE_ABSTRACT: 'Родитель должен быть абстрактным классом',
      PRIMITIVE_CANNOT_BE_REFERENCE: 'Примитивный тип не может быть ссылкой',
      // Изоляция фичи: ссылка объекта фичи ведёт только на объект той же фичи
      // (spec/invariants/feature-isolation.md, R01, R04, R06).
      PACKAGE_FROM_ANOTHER_FEATURE: 'Пакет "{name}" принадлежит другой фиче — объект нельзя в него поместить',
      PARENT_PACKAGE_FROM_ANOTHER_FEATURE: 'Пакет "{name}" принадлежит другой фиче — его нельзя сделать родительским',
      PARENT_CLASS_FROM_ANOTHER_FEATURE: 'Родительский класс принадлежит другой фиче',
      TYPE_CLASS_FROM_ANOTHER_FEATURE: 'Класс-тип поля принадлежит другой фиче',
      EDGE_FIELD_FROM_ANOTHER_FEATURE: 'Поле "{name}" принадлежит другой фиче — его связь на этой диаграмме скрыть нельзя',
      EDGE_CLASS_FROM_ANOTHER_FEATURE: 'Класс "{name}" принадлежит другой фиче — его связь на этой диаграмме скрыть нельзя',
      CLASS_NOT_FOUND: 'Класс не найден',
      FIELD_NOT_FOUND: 'Поле не найдено',
      ENUM_VALUE_NOT_FOUND: 'Значение перечисления не найдено',
      DELETE_FAILED: 'Не удалось удалить',
      CREATE_FAILED: 'Не удалось создать',
      UPDATE_FAILED: 'Не удалось обновить',
      LOAD_FAILED: 'Не удалось загрузить бизнес-модель',
      UNKNOWN_ERROR: 'Неизвестная ошибка',
    },
    export: {
      // Итог выгрузки с предупреждениями (export-R10, R11)
      completedWithWarnings: 'Выгружено с предупреждениями',
      warningDiagram: 'не удалось получить изображение диаграммы «{name}»',
      warningPackage: 'не удалось получить диаграммы пакета «{name}»',
      button: 'Экспорт документации',
      title: 'Экспорт документации',
      progress: 'Экспорт: {progress}%',
      success: 'Документация успешно экспортирована',
      error: 'Не удалось экспортировать документацию',
      exporting: 'Экспорт...',
      // Подписи выгружаемого комплекта: он — пользовательская поверхность
      // продукта, его тексты берутся из словарей на языке выгрузки
      // (export-R27, i18n-R02). Названия объектов модели не переводятся.
      document: {
        heading: 'Документация модели «{name}»',
        generatedBy: 'Сформировано в MetaBridge',
        navigation: 'Дерево навигации',
        searchPlaceholder: 'Поиск по названию',
        searchAction: 'Найти',
        nodeExpand: 'Раскрыть узел',
        nodeCollapse: 'Свернуть узел',
        searchEmpty: 'Ничего не найдено',
        diagrams: 'Диаграммы',
        subPackages: 'Подпакеты',
        classes: 'Классы',
        documentation: 'Описание',
        generalization: 'Родительский класс',
        inheritors: 'Наследники',
        enumValues: 'Значения перечисления',
        attributes: 'Поля',
        abstract: 'абстрактный',
        columnValue: 'Значение',
        columnDocumentation: 'Описание',
        columnName: 'Имя',
        columnType: 'Тип',
        columnCardinality: 'Кратность',
      },
      steps: {
        fetchingGraph: 'Загрузка графа...',
        fetchingPackages: 'Загрузка пакетов...',
        generatingHtml: 'Генерация HTML...',
        creatingZip: 'Создание архива...',
        generatingPackages: 'Генерация страниц пакетов...',
        downloading: 'Скачивание...',
      },
    },
  },

  admin: {
    users: {
      title: 'Пользователи',
      fullName: 'Полное имя',
      login: 'Логин',
      email: 'Email',
      role: 'Роль',
      status: 'Статус',
      active: 'Активен',
      inactive: 'Заблокирован',
      isAdmin: 'Администратор',
      editUser: 'Редактировать',
      resetPassword: 'Сбросить пароль',
      newPassword: 'Новый пароль',
      mustChangePassword: 'Требовать смену при входе',
      saveSuccess: 'Пользователь обновлён',
      resetSuccess: 'Пароль сброшен',
      cannotDeactivateSelf: 'Нельзя деактивировать себя',
      createUser: 'Создать пользователя',
      createSuccess: 'Пользователь создан',
      password: 'Пароль',
      passwordHint: 'Минимум {min} символов',
      blockUser: 'Заблокировать',
      unblockUser: 'Разблокировать',
      userBlocked: 'Пользователь заблокирован',
      userUnblocked: 'Пользователь разблокирован',
      errors: {
        ACCESS_DENIED: 'Доступ запрещён',
        USER_NOT_FOUND: 'Пользователь не найден',
        CANNOT_DEACTIVATE_SELF: 'Нельзя деактивировать себя',
        PASSWORD_TOO_WEAK: 'Пароль слишком слабый',
        LOGIN_ALREADY_EXISTS: 'Логин уже занят',
        EMAIL_ALREADY_EXISTS: 'Email уже занят',
        INVALID_LOGIN_FORMAT: 'Логин может содержать только строчные латинские буквы, цифры, _ и -',
        UNKNOWN_ERROR: 'Неизвестная ошибка',
      },
    },
  },

  mapping: {
    title: 'Маппинги',
    sources: 'источник | источников',
    source: {
      capture: {
        title: 'Стратегия захвата',
        button: 'Стратегия: {label}',
        save: 'Сохранить',
        cancel: 'Отмена',
        strategies: {
          full_refresh: 'Полная выгрузка',
          incremental_column: 'По колонке',
          log_table: 'Через лог-таблицу',
          cdc_stream: 'CDC-поток',
          custom: 'Произвольный WHERE',
        },
        // Неразобранная сохранённая настройка захвата (capture-strategy-R22).
        unparsed: {
          label: 'Ошибка загрузки настройки',
          reasons: {
            unknown_strategy: 'Стратегия «{capture}» продукту неизвестна.',
            config_missing: 'Стратегия «{capture}» требует конфигурацию, но она отсутствует.',
            config_mismatch: 'Конфигурация не соответствует стратегии «{capture}».',
          },
        },
        // Каскад выбора таблицы журнала (mapping-capture-strategy-R26):
        // ручного ввода идентификатора объекта нет.
        logTable: {
          selectSource: 'Выберите источник данных',
          selectSchema: 'Выберите схему',
          selectTable: 'Выберите таблицу',
          ungrouped: 'Без группы',
        },
        fields: {
          strategy: 'Стратегия',
          cursorColumn: 'Колонка-курсор',
          cursorType: 'Тип курсора',
          lookbackWindow: 'Окно лукбек',
          logTableEntity: 'Таблица журнала',
          operationColumn: 'Колонка операции',
          timestampColumn: 'Колонка времени',
          keyColumns: 'Ключевые колонки',
          slotName: 'Имя слота',
          format: 'Формат',
          whereTemplate: 'Шаблон WHERE',
          whereOverride: 'Переопределение WHERE',
        },
        cursorTypes: {
          timestamp: 'Временная метка',
          numeric: 'Число',
          batch_id: 'Batch ID',
        },
        cdcFormats: {
          wal2json: 'wal2json',
          debezium: 'Debezium',
        },
        placeholders: {
          cursorColumn: 'Например: update_time',
          lookbackWindow: 'ISO 8601, например PT1H',
          operationColumn: 'Например: op',
          timestampColumn: 'Например: changed_at',
          keyColumns: 'Каждая колонка с новой строки',
          slotName: 'Например: metabridge_slot',
          whereTemplate: 'Шаблон WHERE для кастомной стратегии',
          whereOverride: 'SQL-фрагмент, применяемый сверх стратегии',
        },
        hints: {
          lookbackWindow: 'Период, в который данные могут запаздывать. Пример: PT1H (1 час).',
          keyColumns: 'Каждая ключевая колонка с новой строки. Минимум одна.',
          whereOverride: 'Произвольное условие, встраиваемое в итоговый SQL генератором. Значение используется как есть — не вставляйте непроверенные данные.',
        },
        errors: {
          required: 'Обязательное поле',
          invalidLookback: 'Ожидается формат ISO 8601 (например PT1H)',
        },
        success: {
          saved: 'Стратегия захвата сохранена',
        },
      },
    },
    actions: {
      create: 'Создать',
    },
    sidebar: {
      title: 'Маппинги',
      searchPlaceholder: 'Поиск маппингов...',
      noMappings: 'Маппинги не найдены',
      selectFeature: 'Выберите feature для просмотра маппингов',
      createMapping: 'Создать маппинг',
      sourceToTarget: 'Источник → Цель',
      targetToSource: 'Цель → Источник',
    },
    workspace: {
      selectMapping: 'Выберите маппинг для редактирования',
      placeholder: 'Редактор маппинга будет здесь',
      placeholderDescription: 'Здесь будет интерфейс для настройки связей между полями источника и целевого класса.',
    },
    tree: {
      sources: 'Источники',
      bmModel: 'Модель BM',
      noSources: 'Нет доступных источников',
      noClasses: 'Нет доступных классов',
      mappingsCount: '{count} маппингов',
      empty: 'Нет маппингов',
      mode: {
        sourceToTarget: 'Источник / Цель',
        targetToSource: 'Цель / Источник',
      },
      contextMenu: {
        createMapping: 'Создать маппинг',
        renameMapping: 'Переименовать',
        deleteMapping: 'Удалить',
      },
      // Сбой загрузки ветки дерева виден на узле (строка таблицы ошибок
      // mappings.md, вердикт 195): пустая ветка означает только отсутствие
      // данных, а не сбой.
      branchError: {
        label: 'Не удалось загрузить',
        retry: 'Повторить',
      },
      emptyState: {
        sources: 'Нет источников данных',
        packages: 'Нет пакетов BM',
        schemas: 'Нет схем',
        tables: 'Нет таблиц',
        classes: 'Нет классов',
      },
      ungroupedProvider: 'Без провайдера',
    },
    createDialog: {
      title: 'Создать маппинг',
      name: 'Название',
      namePlaceholder: 'Введите название маппинга',
      nameRequired: 'Укажите название',
      selectClassFirst: 'Выберите целевой класс',
      selectTableFirst: 'Выберите таблицу-источник',
      targetClass: 'Целевой класс',
      selectClass: 'Выберите целевой класс',
      source: 'Источник данных',
      schema: 'Схема',
      table: 'Таблица',
      selectSource: 'Выберите источник',
      selectSchema: 'Выберите схему',
      selectTable: 'Выберите таблицу',
    },
    editor: {
      placeholder: {
        title: 'Редактор маппинга',
        description: 'Здесь будет интерфейс для настройки связей между полями источника и целевого класса.',
      },
      sourcePanel: {
        title: 'Источники',
        noSources: 'Нет таблиц-источников',
        table: 'Таблица',
        noColumns: 'Нет колонок',
        addSource: 'Добавить таблицу',
        addSourceTitle: 'Добавить таблицу-источник',
        selectSource: 'Источник данных',
        selectSourcePlaceholder: 'Выберите источник',
        selectSchema: 'Схема',
        selectSchemaPlaceholder: 'Выберите схему',
        selectTable: 'Таблица',
        selectTablePlaceholder: 'Выберите таблицу',
        aliasLabel: 'Алиас',
        aliasPlaceholder: 'Краткое имя таблицы',
        existingSourcesHint: 'Используйте алиасы таблиц в условии связи:',
        joinConditionLabel: 'Условие связи (JOIN)',
        joinConditionPlaceholder: 'например: src.id = new.parent_id',
        joinCondition: 'JOIN: {condition}',
        deleteSourceTitle: 'Удаление источника',
        deleteSourceConfirm: 'Удалить таблицу-источник «{name}»? Привязанные правила маппинга потеряют ссылку на источник.',
        addSourceSuccess: 'Таблица-источник добавлена',
        deleteSourceSuccess: 'Таблица-источник удалена',
        unconfirmed: 'Источник не подтверждает',
        unconfirmedTable: 'Источник не подтверждает: таблицы #{id} нет в источнике данных. Уберите источник или переназначьте ему таблицу.',
        unconfirmedName: 'Таблица не подтверждена',
      },
      rulesPanel: {
        title: 'Правила маппинга',
        noRules: 'Нет правил маппинга',
        dropHere: 'Перетащите колонку из панели источников для создания правила',
        addRule: 'Добавить',
        collapseGroup: 'Свернуть группу',
        expandGroup: 'Развернуть группу',
      },
      targetPanel: {
        title: 'Целевой класс',
        noTarget: 'Целевой класс не найден',
        extension: 'Расширение',
        inherited: 'Унаследовано от',
        ownAttributes: 'Собственные атрибуты',
        noFields: 'Нет полей',
        expandNested: 'Раскрыть вложенные поля',
        collapseNested: 'Свернуть вложенные поля',
        enumMore: '...и ещё {count}',
        collectionItem: 'Элемент коллекции',
        expandCollection: 'Показать элемент коллекции',
        collapseCollection: 'Скрыть элемент коллекции',
        flatView: 'Плоский список',
        groupedView: 'Группировка по классам',
      },
      rule: {
        // Правка выражения источника и очистка привязок (rules-R12)
        sourceExpression: 'Выражение источника',
        clearSource: 'Очистить вход',
        clearTarget: 'Очистить цель',
        source: 'Источник',
        target: 'Цель',
        transform: 'Трансформация',
        wholeTable: 'Таблица целиком',
        dragTable: 'Перетащите на коллекцию',
        unbound: 'Не привязано',
        delete: 'Удалить правило',
        edit: 'Редактировать',
        expression: 'Выражение',
        iterator: 'Итератор: {className}',
        phantomIterator: 'Назначьте итератор',
        classIterator: 'Итератор: {className}',
        extensionIterator: 'Расширение: {className}',
        phantomClassIterator: 'Назначьте источник итерации',
        nestedRulesCount: '{count} вложенных',
      },
      alias: {
        editTooltip: 'Нажмите для редактирования алиаса',
        placeholder: 'Алиас',
      },
    },
    stages: {
      filter: 'Фильтр',
      computedFields: 'Вычисляемые поля',
      grouping: 'Группировка',
      uniqueness: 'Уникализация',
      exists: 'Exists',
      setOperation: 'Set operation',
      fieldName: 'Поле',
      expression: 'Выражение',
      alias: 'Алиас',
      mode: 'Режим',
      leftField: 'Левое поле',
      rightField: 'Правое поле',
      condition: 'Условие',
      addCondition: 'Добавить условие',
      addComputedField: 'Добавить поле',
      addAggregation: 'Добавить агрегацию',
      groupBy: 'Поля группировки',
      branchSources: 'Источники ветки',
      addSource: 'Добавить источник',
      noBranchSources: 'Источники ветки не выбраны',
      primary: 'Первичный',
    },
    staging: {
      title: 'Подготовка staging',
      fieldUnconfirmed: 'источник не подтверждает',
      addStage: 'Добавить стадию',
      deleteStage: 'Удалить стадию',
      confirmDelete: 'Удалить стадию «{name}»?',
      stageName: 'Название стадии',
      moveUp: 'Переместить выше',
      moveDown: 'Переместить ниже',
      branchSources: 'Дополнительные источники',
      emptyList: 'Ещё не добавлены стадии',
      status: {
        filtered: 'в фильтре',
        grouped: 'группировка',
        aggregated: '{function} → {alias}',
        computed: 'вычисляется как {alias}',
        distinct: 'distinct on',
        existsJoin: 'условие exists',
      },
    },
    pipeline: {
      previousFields: 'Поля предыдущего шага',
      noFields: 'Нет полей предыдущего шага',
      unbound: 'Не привязано',
      // Системные узлы конвейера в панели (mapping-pipeline-R47, R03).
      // Подписи узлов — только отсюда: хранимое имя системного узла подписью
      // не является и пользователю не показывается нигде.
      systemNodes: {
        kind: 'Системный узел',
        source: 'Источник',
        mapping: 'Маппинг',
        attachedSources: 'Источники маппинга',
        noSources: 'Источников нет',
        targetClass: 'Целевой класс',
        noTargetClass: 'Целевой класс не определён',
        fields: 'Поля узла',
      },
      // Нераспознанное хранимое значение элемента конвейера (вердикт 206).
      unreadable: {
        label: 'Не удалось прочитать',
        nodeKind: 'вид узла ({value})',
        stageType: 'тип стадии ({value})',
        fieldKind: 'вид поля ({value})',
        conflict: 'Изменить нельзя: {element}.',
      },
      // Разрешение расхождения конвейера с источником человеком
      // (mapping-pipeline-R45).
      unconfirmedFields: {
        title: 'Неподтверждённые поля',
        remove: 'Убрать',
        confirm: 'Убрать поле «{name}» из конвейера? Действие не журналируется и отмене не подлежит.',
        inUse: 'Поле убрать нельзя: на него опираются правила ({rules}) и стадии ({stages}): {stageNames}.',
        confirmed: 'Поле подтверждается источником — убирать нечего.',
        failed: 'Не удалось убрать поле.',
      },
    },
    // Перечитывание раздела после отмены/возврата не удалось (строка таблицы
    // ошибок mappings.md, вердикт 196).
    stale: {
      title: 'Данные могли устареть',
      message: 'Не удалось перечитать маппинги: данные могли устареть',
      refresh: 'Обновить',
    },
    dialogs: {
      createTitle: 'Создать маппинг',
      renameTitle: 'Переименовать маппинг',
      deleteTitle: 'Удалить маппинг',
      deleteConfirm: 'Вы уверены, что хотите удалить маппинг "{name}"?',
      name: 'Название',
      namePlaceholder: 'Введите название маппинга',
      targetClass: 'Целевой класс',
      targetClassPlaceholder: 'Выберите целевой класс',
    },
    errors: {
      MAPPING_NOT_FOUND: 'Маппинг не найден',
      // Изоляция фичи: целевой класс маппинга — седьмая ссылка реестра
      // (spec/invariants/feature-isolation.md, R06).
      TARGET_CLASS_FROM_ANOTHER_FEATURE:
        'Класс "{name}" принадлежит другой фиче — он не может быть целью маппинга',
      // Способ получения данных источника (spec/features/mapping/capture-strategy.md).
      INCREMENTAL_CAPTURE_STRATEGY_UNKNOWN:
        'Неизвестный способ получения данных: "{strategy}"',
      CAPTURE_CONFIG_UNEXPECTED: 'Способ получения данных "{strategy}" не имеет параметров',
      CAPTURE_CONFIG_REQUIRED: 'Способ получения данных "{strategy}" требует параметров',
      CAPTURE_CONFIG_INVALID: 'Параметры не соответствуют способу получения данных "{strategy}"',
      CAPTURE_CONFIG_FIELD_EMPTY: 'Значение "{field}" не может быть пустым',
      CAPTURE_CONFIG_LOOKBACK_INVALID:
        'Окно перечитывания "{value}" задано неверно: ожидается, например, PT1H, PT30M или P1D',
      CAPTURE_CONFIG_KEY_COLUMNS_EMPTY: 'Укажите хотя бы одну ключевую колонку',
      LOG_TABLE_ENTITY_NOT_FOUND: 'Таблица журнала не найдена',
      TABLE_HAS_MAPPINGS: 'Невозможно удалить таблицу: есть связанные маппинги',
      CLASS_HAS_MAPPINGS: 'Невозможно удалить класс: есть связанные маппинги',
      CREATE_FAILED: 'Не удалось создать маппинг',
      UPDATE_FAILED: 'Не удалось обновить маппинг',
      DELETE_FAILED: 'Не удалось удалить маппинг',
      LOAD_FAILED: 'Не удалось загрузить маппинги',
    },
    success: {
      created: 'Маппинг создан',
      renamed: 'Маппинг переименован',
      deleted: 'Маппинг удалён',
    },
  },

  connection: {
    types: {
      database: 'База данных',
      ftp: 'FTP',
      sftp: 'SFTP',
      s3: 'S3',
      local_path: 'Локальный путь',
      webapi: 'Web API',
      kafka: 'Kafka',
    },
    dataProviders: {
      database: 'База данных',
      excel: 'Excel',
      csv: 'CSV',
      json: 'JSON',
      xml: 'XML',
    },
    addGroup: 'Добавить группу',
    addConnection: 'Добавить подключение',
    connectionType: 'Тип подключения',
    dataProvider: 'Провайдер данных',
    testConnection: 'Проверить подключение',
    addChildItem: 'Добавить элемент',
    s3: {
      bucket: 'Bucket',
      region: 'Регион',
      accessKey: 'Access Key',
      secretKey: 'Secret Key',
    },
    webApi: {
      baseUrl: 'Base URL',
      authType: 'Тип авторизации',
      authNone: 'Нет',
      authBearer: 'Bearer Token',
      authBasic: 'Базовая аутентификация',
      authApiKey: 'API Key',
      tokenKey: 'Токен / Ключ',
      headerName: 'Имя заголовка',
    },
    kafka: {
      brokers: 'Брокеры',
      securityProtocol: 'Протокол безопасности',
      plaintext: 'Plaintext',
      ssl: 'SSL',
      saslSsl: 'SASL_SSL',
      saslPlaintext: 'SASL_PLAINTEXT',
      saslMechanism: 'SASL Механизм',
      schemaRegistryUrl: 'Schema Registry URL',
    },
  },

  filePattern: {
    filePatterns: 'Файловые маски',
    name: 'Название',
    fileMask: 'Маска файла',
    filePath: 'Путь к файлу',
    addFilePattern: 'Добавить маску',
    addTitle: 'Добавить файловую маску',
    fileMaskPlaceholder: '*.csv, report_*.xlsx',
    filePathPlaceholder: '/data/reports',
    dataProvider: 'Формат данных',
    delimiter: 'Разделитель',
    encoding: 'Кодировка',
    headerRow: 'Строка заголовка',
    deleteConfirm: 'Удалить маску \u00AB{name}\u00BB?',
  },

  endpoint: {
    endpoints: 'Endpoints',
    name: 'Название',
    method: 'HTTP метод',
    path: 'Путь',
    addEndpoint: 'Добавить endpoint',
    addTitle: 'Добавить endpoint',
    methodPlaceholder: 'GET',
    pathPlaceholder: '/api/users',
    deleteConfirm: 'Удалить endpoint \u00AB{name}\u00BB?',
  },

  topic: {
    topics: 'Топики',
    name: 'Название',
    topicName: 'Имя топика',
    addTopic: 'Добавить топик',
    addTitle: 'Добавить топик',
    topicNamePlaceholder: 'events.orders',
    deleteConfirm: 'Удалить топик \u00AB{name}\u00BB?',
  },

  datamart: {
    title: 'Витрины',
    // Повтор неудавшейся загрузки: сбой всегда сопровождается действием
    // (spec/features/datamarts/datamarts.md R09, columns.md R02).
    retry: 'Повторить',
    // Перечитать раздел не удалось после отмены или возврата изменений
    // (spec/features/datamarts/datamarts.md, R11): молчать нельзя.
    stale: {
      title: 'Данные могли устареть',
      message: 'Не удалось перечитать витрины: данные могли устареть',
      refresh: 'Обновить',
    },
    sidebar: {
      title: 'Витрины',
      search: 'Поиск витрин...',
      createDatamart: 'Создать витрину',
      createFolder: 'Создать папку',
      createSubfolder: 'Создать подпапку',
      rename: 'Переименовать',
      duplicate: 'Дублировать',
      moveTo: 'Переместить в папку...',
      delete: 'Удалить',
      deleteConfirm: 'Удалить витрину \u00AB{name}\u00BB?',
      // Подтверждение не обещает удалить содержимое: удалить можно только
      // пустую папку (spec/features/datamarts/folders.md, R14, R15).
      deleteFolderConfirm: 'Удалить папку \u00AB{name}\u00BB?',
      open: 'Открыть',
    },
    // Перенос папки в другую папку той же фичи или в корень
    // (spec/features/datamarts/folders.md, R12).
    moveFolderDialog: {
      title: 'Переместить папку «{name}»',
      target: 'Куда переместить',
      root: 'В корень фичи',
      placeholder: 'Выберите папку',
      moved: 'Папка перемещена',
    },
    workspace: {
      selectDatamart: 'Выберите витрину из панели слева или создайте новую',
    },
    toolbar: {
      addColumn: 'Добавить колонку',
      previewSql: 'Просмотр SQL',
      validate: 'Валидация',
      properties: 'Свойства',
    },
    bmPanel: {
      title: 'BM Модель',
      search: 'Поиск полей...',
      empty: 'Бизнес-модель пуста. Сначала создайте классы в модуле BM.',
      collapse: 'Свернуть панель',
      expand: 'Развернуть панель',
      // Узел пакета подписан названием; названия нет — «Без названия», но
      // никогда не служебный идентификатор
      // (spec/features/datamarts/columns.md, R34).
      unnamedPackage: 'Без названия',
    },
    columns: {
      title: 'Колонки',
      name: 'Имя колонки',
      dataType: 'Тип данных',
      sourceBm: 'Источник (BM)',
      expression: 'Выражение',
      groupBy: 'GRP',
      actions: 'Действия',
      dropHint: 'Перетащите поле BM сюда',
      dropZone: 'Перетащите поля BM сюда или нажмите Добавить колонку',
      emptyState: 'Колонки ещё не определены',
      namePlaceholder: 'имя_колонки',
      expressionPlaceholder: 'напр. SUM(field), COUNT(*)',
      unlinked: 'Нет источника',
    },
    querySummary: {
      title: 'Сводка запроса',
      groupBy: 'GROUP BY',
      orderBy: 'ORDER BY',
      filters: 'ФИЛЬТРЫ',
    },
    createDialog: {
      title: 'Создать витрину',
      name: 'Название витрины',
      namePlaceholder: 'моя_витрина',
      folder: 'Папка',
      folderPlaceholder: 'Выберите папку',
      newFolder: 'Новая папка...',
      // Пустое имя новой папки не отправляется
      // (spec/features/datamarts/datamarts.md, R23).
      newFolderNameRequired: 'Укажите название новой папки',
      description: 'Описание',
      descriptionPlaceholder: 'Описание витрины (необязательно)',
    },
    propertiesDialog: {
      title: 'Свойства витрины',
      clickhouseSettings: 'Настройки ClickHouse',
      engine: 'Движок',
      orderBy: 'ORDER BY',
      orderByPlaceholder: 'column1, column2',
      ttl: 'TTL',
      ttlPlaceholder: 'event_date + INTERVAL 1 MONTH',
    },
    previewDialog: {
      title: 'Просмотр SQL',
      copy: 'Копировать',
      copied: 'Скопировано!',
      empty: 'Добавьте колонки для генерации SQL',
    },
    expressionHelpers: {
      sum: 'SUM',
      count: 'COUNT',
      avg: 'AVG',
      min: 'MIN',
      max: 'MAX',
      concat: 'CONCAT',
      coalesce: 'COALESCE',
      caseWhen: 'CASE',
    },
    errors: {
      // Отказ удаления непустой папки: признак причины от продукта,
      // параметры — количества мешающего содержимого
      // (spec/features/datamarts/folders.md, R15).
      DATAMART_FOLDER_NOT_EMPTY:
        'Невозможно удалить папку: в ней {datamartCount} витрин(ы) и {subfolderCount} подпапк(и). Сначала перенесите или удалите содержимое',
      // Название витрины уникально в пределах фичи
      // (spec/features/datamarts/datamarts.md, R38; правило именования копии — R32).
      DATAMART_NAME_EXISTS: 'Витрина с названием «{name}» в этой фиче уже есть',
      DATAMART_NAME_EMPTY: 'Название витрины не может быть пустым',
      DATAMART_FOLDER_NAME_EMPTY: 'Название папки не может быть пустым',
      // Перенос папки внутрь самой себя (spec/features/datamarts/folders.md, R13, R19).
      DATAMART_FOLDER_CYCLE: 'Папку нельзя перенести внутрь неё самой или её подпапки',
      DATAMART_FOLDER_NOT_FOUND: 'Целевая папка не найдена',
      // Название папки уникально среди папок одного родителя
      // (spec/features/datamarts/folders.md, R17).
      DATAMART_FOLDER_NAME_EXISTS: 'Папка с названием «{name}» здесь уже есть',
      // Название колонки уникально в пределах витрины
      // (spec/features/datamarts/columns.md, R42).
      DATAMART_COLUMN_NAME_EXISTS: 'Колонка с названием «{name}» в витрине уже есть',
      DATAMART_COLUMN_NAME_EMPTY: 'Название колонки не может быть пустым',
      // Тип данных обязателен и берётся из перечня (columns.md, R44).
      DATAMART_COLUMN_TYPE_EMPTY: 'Тип данных колонки не может быть пустым',
      DATAMART_COLUMN_TYPE_UNKNOWN: 'Тип данных «{dataType}» недопустим',
      // Направление сортировки — только ASC или DESC (columns.md, R45).
      DATAMART_SORT_DIRECTION_UNKNOWN:
        'Направление сортировки может быть только ASC или DESC',
      // Движок целевого хранилища берётся из перечня (target-storage.md, R04).
      DATAMART_ENGINE_UNKNOWN: 'Движок «{engine}» недопустим',
      // Принадлежность фиче (datamarts.md R40, folders.md R20).
      DATAMART_FOLDER_FOREIGN_FEATURE:
        'Папка должна принадлежать той же фиче, что и витрина',
      DATAMART_PARENT_FOLDER_FOREIGN_FEATURE:
        'Родительская папка должна принадлежать той же фиче',
      loadFailed: 'Не удалось загрузить витрины',
      // Сбои загрузки редактора различимы: витрина, её колонки и модель
      // (spec/features/datamarts/columns.md, R02).
      datamartLoadFailed: 'Не удалось загрузить витрину',
      columnsLoadFailed: 'Не удалось загрузить колонки',
      bmGraphLoadFailed: 'Не удалось загрузить бизнес-модель',
      createFailed: 'Не удалось создать витрину',
      updateFailed: 'Не удалось обновить витрину',
      deleteFailed: 'Не удалось удалить витрину',
      // Исход действий над витриной и папкой (datamarts.md R33,
      // folders.md R11, R16).
      duplicateFailed: 'Не удалось дублировать витрину',
      folderCreateFailed: 'Не удалось создать папку',
      folderRenameFailed: 'Не удалось переименовать папку',
      folderDeleteFailed: 'Не удалось удалить папку',
      folderMoveFailed: 'Не удалось переместить папку',
      columnCreateFailed: 'Не удалось создать колонку',
      columnUpdateFailed: 'Не удалось обновить колонку',
      columnDeleteFailed: 'Не удалось удалить колонку',
      validationFailed: 'Ошибка валидации витрины',
    },
    success: {
      created: 'Витрина \u00AB{name}\u00BB создана',
      deleted: 'Витрина удалена',
      duplicated: 'Витрина дублирована',
      // Успешное удаление папки подтверждается (folders.md, R16).
      folderDeleted: 'Папка удалена',
      columnCreated: 'Колонка добавлена',
      columnDeleted: 'Колонка удалена',
    },
  },

  /**
   * История изменений — раздел поверх аудит-лога
   * (spec/features/changelog-undo-redo/change-history.md).
   */
  changeHistory: {
    title: 'История изменений',
    empty: 'По заданным условиям изменений нет',
    truncated: 'Показаны последние 200 групп изменений. Сузьте период, чтобы увидеть остальные.',
    loadFailed: 'Не удалось прочитать историю изменений',
    expandFailed: 'Не удалось раскрыть группу изменений',
    undone: 'Изменение отменено',
    redone: 'Изменение возвращено',
    unknownAuthor: 'Автор неизвестен',
    filters: {
      period: 'Период',
      periodFrom: 'С',
      periodTo: 'По',
      author: 'Автор',
      anyAuthor: 'Любой автор',
      channel: 'Канал',
      anyChannel: 'Любой канал',
      area: 'Область изменения',
      anyArea: 'Все доступные области',
      // «Мой текущий сеанс» — замена отдельной поверхности «история сеанса»
      // (spec/features/changelog-undo-redo/change-history.md, R08).
      mySession: 'Только правки моего текущего сеанса',
      apply: 'Применить',
      clear: 'Сбросить',
    },
    column: {
      moment: 'Момент',
      author: 'Автор',
      channel: 'Канал',
      scope: 'Охват',
      state: 'Состояние',
      object: 'Объект',
      operation: 'Операция',
      fields: 'Изменения полей',
    },
    channel: {
      ui: 'Интерфейс',
      mcp: 'AI-агент',
    },
    area: {
      business_model: 'Бизнес-модель',
      mapping: 'Маппинг',
      notes_and_tags: 'Заметки и разметка',
      dictionaries: 'Справочники',
      datamarts: 'Витрины',
    },
    scope: {
      actions: '{count} действ.',
    },
    state: {
      applied: 'Действует',
      undone: 'Отменено',
      undoneBy: 'Отменил(а) {author}, {moment}',
    },
    action: {
      undo: 'Отменить',
      redo: 'Вернуть',
    },
    operation: {
      create: 'Создание',
      update: 'Изменение',
      delete: 'Удаление',
      unknown: 'Операция',
    },
    details: {
      title: 'Действия группы',
    },
    entityKind: {
      bm_class: 'Класс',
      bm_field: 'Поле класса',
      bm_enum_value: 'Значение перечисления',
      bm_package: 'Пакет',
      bm_diagram: 'Диаграмма',
      bm_diagram_object: 'Объект диаграммы',
      bm_diagram_hidden_edge: 'Скрытая связь диаграммы',
      mapping: 'Маппинг',
      mapping_source: 'Источник маппинга',
      mapping_rule: 'Правило маппинга',
      mapping_stage: 'Стадия конвейера',
      mapping_stage_config: 'Настройка стадии',
      pipeline_node: 'Узел конвейера',
      pipeline_field: 'Поле конвейера',
      pipeline_lineage: 'Происхождение поля',
      entity_note: 'Заметка',
      entity_tag: 'Тег объекта',
      comment: 'Комментарий',
      tag: 'Тег',
      tag_category: 'Категория тегов',
      datamart: 'Витрина',
      datamart_column: 'Колонка витрины',
      datamart_folder: 'Папка витрин',
    },
    // Подписи объектов, у которых собственного названия нет: системные узлы
    // конвейера подписываются на языке интерфейса (mapping-pipeline-R03).
    objectCaption: {
      pipeline_source: 'Источник',
      pipeline_mapping: 'Маппинг',
    },
  },

  undoRedo: {
    undo: 'Отменить',
    redo: 'Повторить',
    nothingToUndo: 'Нечего отменять',
    nothingToRedo: 'Нечего повторять',
    undoFailed: 'Не удалось отменить действие',
    redoFailed: 'Не удалось повторить действие',
    conflict: 'Конфликт: изменение затронуто более поздней правкой',
    /**
     * Тексты отказов отмены и возврата по признаку причины
     * (undo-redo-R19, i18n-R06): каждый отказ доводится до пользователя, и
     * молчаливое гашение недопустимо. Имён хранения в текстах нет — перечень
     * видов сущностей задаёт audit-R12 (undo-redo-R18).
     */
    errors: {
      // Отмена и возврат доступны только при выбранной фиче (versioning-R21)
      FEATURE_NOT_SELECTED: 'Фича не выбрана',
      NOTHING_TO_UNDO: 'Нечего отменять',
      NOTHING_TO_REDO: 'Нечего возвращать',
      UNDO_CONFLICT: 'Конфликт: изменение затронуто более поздней правкой',
      SESSION_NOT_FOUND: 'Сеанс редактирования не найден',
      SESSION_CLOSED: 'Сеанс редактирования закрыт',
      ACCESS_DENIED: 'Недостаточно прав на отмену этого изменения',
      STORAGE_ERROR: 'Отмена не удалась',
      NETWORK_ERROR: 'Отмена не удалась: нет связи с сервером',
    },
  },
};
